import { FC, useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';

import { DataFilterControl, DataFilterRequest } from '../../../../../hooks/DataFilter/DataFilterControl';
import Row from '../../../../../components/Row';

import { InventorySource as DspInventorySource } from '../../../../../types/Inventory';

interface CampaignAdGroupInventoryDataGridFilterProps {
    rows: DspInventorySource[];
    onFilterChange?: (filteredRows: DspInventorySource[]) => void;
}

const CampaignAdGroupInventoryDataGridFilter: FC<CampaignAdGroupInventoryDataGridFilterProps> = ({
    rows,
    onFilterChange,
}) => {
    const [filterRequest, setFilterRequest] = useState<DataFilterRequest<DspInventorySource>>({
        filters: [],
        page: 1,
        pageSize: 25,
    });

    const inventorySourceTypeOptions = useMemo(
        () => Array.from(new Set(rows.map((r) => r.inventorySourceType))),
        [rows]
    );

    const filteredRows = useMemo(() => {
        return filterRequest.filters.reduce<DspInventorySource[]>((acc, crit) => {
            if (crit.operator === 'equals') {
                return acc.filter((r) => r[crit.field] === crit.value);
            }
            return acc;
        }, rows);
    }, [rows, filterRequest]);

    useEffect((): void => {
        onFilterChange?.(filteredRows);
    }, [filteredRows, onFilterChange]);

    return (
        <Row>
            <Box width={320}>
                <DataFilterControl<DspInventorySource>
                    filterRequest={filterRequest}
                    onFilterChange={setFilterRequest}
                    field="inventorySourceType"
                    label="Inventory Source"
                    options={inventorySourceTypeOptions}
                />
            </Box>
        </Row>
    );
};

export default CampaignAdGroupInventoryDataGridFilter;
